<router-outlet></router-outlet>

<!-- <ngx-spinner type="ball-scale-multiple" bdColor="#121b2bb3"  size="medium" color="#FFF" ></ngx-spinner> -->
<ngx-spinner
  type="ball-scale-multiple"
  bdColor="rgba(232,234,237,0.9)"
  size="medium"
  [color]="spinnerColor"
  [fullScreen]="false"
></ngx-spinner>
